/* InLei storefront glue: real cart + real forms for the design components */
(function () {
  function emit(count) { window.dispatchEvent(new CustomEvent('inlei:cart', { detail: { count: count } })); }
  function refresh() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { emit(c.item_count); return c; }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  window.InleiCart = {
    add: function (variantId, qty) { return post('/cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] }).then(refresh).catch(function (e) { console.warn(e); }); },
    addHandle: function (href, qty) {
      var h = String(href || '').split('?')[0];
      return fetch(h + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        return window.InleiCart.add(v.id, qty);
      });
    },
    change: function (key, qty) { return post('/cart/change.js', { id: key, quantity: qty }).then(function (c) { emit(c.item_count); return c; }); },
    refresh: refresh
  };

  /* Forms inside design components: send them to Shopify (contact / newsletter) */
  function labelFor(el) {
    if (el.id) { var l = document.querySelector('label[for="' + el.id + '"]'); if (l) return l.textContent.trim(); }
    var p = el.closest('label'); if (p) return p.textContent.trim().slice(0, 80);
    return el.name || el.placeholder || el.type;
  }
  window.DC = window.DC || {};
  var prev = window.DC.onSubmit;
  window.DC.onSubmit = function (form) {
    if (prev) try { prev(form); } catch (e) {}
    if (form.closest('[aria-labelledby="ht-login-title"]')) return;
    var fields = Array.prototype.filter.call(form.querySelectorAll('input, textarea, select'), function (el) { return el.type !== 'submit' && el.type !== 'button'; });
    if (!fields.length) return;
    if (form.querySelector('input[type="search"]')) { var q = form.querySelector('input[type="search"]').value; location.href = '/search?q=' + encodeURIComponent(q); return; }
    var email = '', name = '', lines = [];
    fields.forEach(function (el) {
      var v = el.type === 'checkbox' || el.type === 'radio' ? (el.checked ? 'yes' : '') : el.value;
      if (!v) return;
      if (!email && el.type === 'email') email = v;
      var lb = labelFor(el);
      if (!name && /name/i.test(lb) && el.type === 'text') name = v;
      lines.push(lb + ': ' + v);
    });
    var fd = new FormData();
    fd.append('utf8', '✓');
    var onlyEmail = fields.length <= 2 && email;
    if (onlyEmail) {
      fd.append('form_type', 'customer');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter');
    } else {
      fd.append('form_type', 'contact');
      if (email) fd.append('contact[email]', email);
      if (name) fd.append('contact[name]', name);
      fd.append('contact[body]', (document.title || '') + '\n\n' + lines.join('\n'));
    }
    fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
  };
})();
document.addEventListener('keydown', function (e) {
  var t = e.target;
  if (e.key === 'Enter' && t && t.id === 'ht-q' && t.value.trim()) { e.preventDefault(); location.href = '/search?q=' + encodeURIComponent(t.value.trim()); }
});

window.InleiAuth = (function () {
  function v(id) { var el = document.getElementById(id); return el ? el.value : ''; }
  function go(action, fields) {
    var f = document.createElement('form'); f.method = 'post'; f.action = action; f.style.display = 'none';
    Object.keys(fields).forEach(function (k) { var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = fields[k]; f.appendChild(i); });
    document.body.appendChild(f); f.submit();
  }
  return {
    login: function () { go('/account/login', { form_type: 'customer_login', utf8: '✓', 'customer[email]': v('ht-em'), 'customer[password]': v('ht-pw') }); },
    register: function () { go('/account', { form_type: 'create_customer', utf8: '✓', 'customer[first_name]': v('ht-fn'), 'customer[last_name]': v('ht-ln'), 'customer[email]': v('ht-em2'), 'customer[password]': v('ht-pw2'), 'customer[note][License number]': v('ht-lic'), 'customer[note][License state]': v('ht-st') }); },
    recover: function () { go('/account/recover', { form_type: 'recover_customer_password', utf8: '✓', email: v('ht-em3') }); }
  };
})();

/* Autoplay background videos: browsers only autoplay when the muted *property* is set */
(function () {
  function kick(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('video[autoplay]'), function (v) {
      if (!v.muted) { v.muted = true; v.defaultMuted = true; }
      v.playsInline = true; v.setAttribute('playsinline', '');
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }
  function start() {
    kick();
    new MutationObserver(function () { kick(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
